import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PaymentQrCodeRequest} from "../interface/paymentQrCodeRequest";
import {PaymentQrCodeResponse} from "../interface/PaymentQrCodeResponse";

@Injectable({
  providedIn: "root"
})
export class PaymentQrCodeService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  generateQRCode(paymentQrCodeRequest: PaymentQrCodeRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/payment-qr-codes/generate`, paymentQrCodeRequest, {
      responseType: 'blob'
    });
  }

  checkAndExpireQRCode(paymentQrIdentificationId: string): Observable<PaymentQrCodeResponse> {
    return this.http.post<PaymentQrCodeResponse>(`${this.apiUrl}/payment-qr-codes/expiration/${paymentQrIdentificationId}`, {});
  }
}
